import { render, staticRenderFns } from "./areYouSure.vue?vue&type=template&id=4875fccc&"
import script from "./areYouSure.vue?vue&type=script&lang=js&"
export * from "./areYouSure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports